export { default as colors } from "./colors";
export { default as fonts } from "./fonts";

// Export combined theme object
export const theme = {
  colors: require("./colors").default,
  fonts: require("./fonts").default,
};

export default theme;
